import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn, formatDateTimeVi, getStatusLabel } from '../../../shared/utils';
export function Shell({ title, subtitle, actions, children }) {
    return (_jsxs("section", { className: "page-section", children: [_jsxs("div", { className: "section-head", children: [_jsxs("div", { children: [_jsx("h1", { children: title }), subtitle ? _jsx("p", { children: subtitle }) : null] }), actions ? _jsx("div", { className: "section-actions", children: actions }) : null] }), children] }));
}
export function Card({ title, children, className }) {
    return (_jsxs("div", { className: cn('card', className), children: [title ? _jsx("div", { className: "card-title", children: title }) : null, children] }));
}
export function StatCard({ label, value, helper }) {
    return (_jsxs(Card, { className: "stat-card", children: [_jsx("div", { className: "stat-label", children: label }), _jsx("div", { className: "stat-value", children: value }), helper ? _jsx("div", { className: "stat-helper", children: helper }) : null] }));
}
export function Badge({ children, tone = 'default' }) {
    return _jsx("span", { className: `badge badge-${tone}`, children: children });
}
export function StatusBadge({ status }) {
    const tone = status.includes('da_') || status === 'hoan_tat'
        ? 'good'
        : status.includes('loi') || status.includes('tam')
            ? 'danger'
            : status.includes('cho') || status.includes('nhap') || status.includes('hoan')
                ? 'warn'
                : 'default';
    return _jsx(Badge, { tone: tone, children: getStatusLabel(status) });
}
export function Input(props) {
    return _jsx("input", { ...props, className: cn('input', props.className) });
}
export function TextArea(props) {
    return _jsx("textarea", { ...props, className: cn('textarea', props.className) });
}
export function Select(props) {
    return _jsx("select", { ...props, className: cn('input', props.className) });
}
export function Button({ variant = 'primary', ...props }) {
    return _jsx("button", { ...props, className: cn('button', `button-${variant}`, props.className) });
}
export function EmptyState({ title, text, action }) {
    return (_jsxs(Card, { className: "empty-state", children: [_jsx("div", { className: "empty-icon", children: "\uD83E\uDEE7" }), _jsx("h3", { children: title }), _jsx("p", { children: text }), action] }));
}
export function Modal({ open, title, children, onClose }) {
    if (!open)
        return null;
    return (_jsx("div", { className: "modal-backdrop", onClick: onClose, children: _jsxs("div", { className: "modal-card", onClick: (event) => event.stopPropagation(), children: [_jsxs("div", { className: "modal-head", children: [_jsx("h3", { children: title }), _jsx("button", { className: "icon-button", onClick: onClose, children: "\u2715" })] }), children] }) }));
}
export function ConfirmDialog({ open, title, description, onConfirm, onClose }) {
    return (_jsxs(Modal, { open: open, title: title, onClose: onClose, children: [_jsx("p", { className: "modal-copy", children: description }), _jsxs("div", { className: "modal-actions", children: [_jsx(Button, { variant: "secondary", onClick: onClose, children: "H\u1EE7y" }), _jsx(Button, { variant: "danger", onClick: onConfirm, children: "X\u00E1c nh\u1EADn x\u00F3a" })] })] }));
}
export function ToastStack({ items, onDismiss }) {
    return (_jsx("div", { className: "toast-stack", children: items.map((item) => (_jsx("button", { className: `toast toast-${item.type}`, onClick: () => onDismiss(item.id), title: "Ch\u1EA1m \u0111\u1EC3 \u0111\u00F3ng", children: item.message }, item.id))) }));
}
export function SkeletonList() {
    return (_jsx("div", { className: "skeleton-list", children: Array.from({ length: 3 }).map((_, index) => (_jsx("div", { className: "skeleton-card" }, index))) }));
}
export function ItemMeta({ createdAt }) {
    return _jsxs("small", { className: "item-meta", children: ["C\u1EADp nh\u1EADt ", formatDateTimeVi(createdAt)] });
}
